var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7936 37.1832C21.9168 37.1209 22.0324 37.0384 22.1353 36.9355L40.5182 18.5526C41.0386 18.0322 41.0403 17.1871 40.5201 16.667L39.5753 15.7222C39.0569 15.2038 38.211 15.2029 37.6898 15.7241L21.1905 32.2234L13.8863 24.9191C13.3627 24.3955 12.5203 24.3965 12.0002 24.9166L11.0554 25.8614C10.537 26.3798 10.5364 27.226 11.0579 27.7476L20.2452 36.9349C20.6663 37.356 21.2936 37.4378 21.7936 37.1832ZM0 26C0 11.6406 11.6374 0 26 0C40.3594 0 52 11.6374 52 26C52 40.3594 40.3626 52 26 52C11.6406 52 0 40.3626 0 26Z",
    fill: "#EAA827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.1ac9f9bde214f1eb0c6ef766ba35dc2c.svg";
export { ForwardRef as ReactComponent };